import i18n from 'i18next';
import importResourceBundleBackend from './importResourceBundleBackend';
import {initReactI18next} from 'react-i18next';

export const supportedLngs = ['en', 'ja']; /* add these once ready to support: 'fr', 'de', 'ko', 'es', 'it', 'pt', 'zh-cn', 'zh-tw' */

const getLangByHtmlElement = () => document.querySelector('html').getAttribute('lang') || 'en';

i18n
  .use(importResourceBundleBackend)
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV === 'development',
    lng: getLangByHtmlElement(),
    lowerCaseLng: true,
    supportedLngs,
    fallbackLng: 'en',
    ns: ['translation', 'seo'],
    defaultNs: 'translation',
    keySeparator: false,
    interpolation: {
      escapeValue: false /* not needed for react as it escapes by default */,
    },
  });

export default i18n;
